/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Shock Icon component.
 */
export const ShockIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13.8487 8.44615L16.2857 1L7 10.7112H10.3613L7 15.2154H10.0042L7 23L17 12.5076H13.8487L17 8.44615H13.8487Z' fill='white' stroke={iconColor} strokeWidth='1.25' strokeLinejoin='round' />
    </svg>
  );
};

export default ShockIcon;
